import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";

export default class StopBounceSymbolBehaviour extends AbstractSymbolBehaviour {

    public static BOUNCE_SCALE: number = 0.85;
    public static BOUNCE_TIME: number = 225;

    public stop() {
        return new Contract<void>((resolve) => {

            const outTransform = this.symbol.getTransform().clone();
            const inTransform = outTransform.clone();

            const transform = outTransform.clone();

            inTransform.width *= StopBounceSymbolBehaviour.BOUNCE_SCALE;
            inTransform.height *= StopBounceSymbolBehaviour.BOUNCE_SCALE;
            inTransform.x += (outTransform.width - inTransform.width) * 0.5;
            inTransform.y += (outTransform.height - inTransform.height) * 0.5;

            const update = () => {
                this.symbol.setTransform(transform);
                this.symbol.updateTransform();
            };

            const inTween = new TweenJS.Tween(transform)
                .to(inTransform, StopBounceSymbolBehaviour.BOUNCE_TIME)
                .easing(TweenJS.Easing.Quadratic.In)
                .onUpdate(update);

            const outTween = new TweenJS.Tween(transform)
                .to(outTransform, StopBounceSymbolBehaviour.BOUNCE_TIME)
                .easing(TweenJS.Easing.Quadratic.Out)
                .onUpdate(update)
                .onComplete(() => resolve(null));

            inTween.chain(outTween)
                .start();
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/stop-bounce-symbol-behaviour.ts